<div class="stbl-card">
  @if (title || hint) {
    <div class="stbl-head">
      <div class="stbl-head-main">
        @if (title) {
          <h2>{{ title }}</h2>
        }
        @if (hint) {
          <p class="stbl-hint">{{ hint }}</p>
        }
      </div>
      <div class="stbl-head-right">
        <ng-content select="[headerRight]"></ng-content>
      </div>
    </div>
  }

  <ng-content select="[filter]"></ng-content>

  <div class="stbl-scroll">
    <table class="stbl">
      <thead>
        <tr>
          @for (col of columns; track col.key) {
            <th [class.num]="col.num">{{ col.label }}</th>
          }
        </tr>
      </thead>
      <tbody>
        @if (loading) {
          <tr>
            <td class="stbl-empty" [attr.colspan]="columns.length || 1">
              Chargement…
            </td>
          </tr>
        } @else if (rows.length) {
          @for (row of rows; track $index) {
            <tr>
              @for (col of columns; track col.key) {
                <td
                  [class.num]="col.num"
                  [class.cell-bold]="col.bold"
                  [class.cell-muted]="col.muted"
                  [class.cell-soft]="col.soft"
                >
                  @if (col.badge) {
                    <span class="tag {{ row[col.key + 'Cls'] || '' }}">{{
                      row[col.key]
                    }}</span>
                  } @else {
                    {{ row[col.key] }}
                  }
                </td>
              }
            </tr>
          }
        } @else {
          <tr>
            <td class="stbl-empty" [attr.colspan]="columns.length || 1">
              {{ emptyText }}
            </td>
          </tr>
        }
      </tbody>
      @if (footerRow && rows.length && !loading) {
        <tfoot>
          <tr>
            @for (col of columns; track col.key) {
              <td [class.num]="col.num">{{ footerRow[col.key] }}</td>
            }
          </tr>
        </tfoot>
      }
    </table>
  </div>

  @if (showPager && totalPages > 1) {
    <div class="stbl-pager">
      <button
        type="button"
        (click)="prev.emit()"
        [disabled]="page <= 1"
        aria-label="Page précédente"
      >
        ‹
      </button>
      <span class="info">Page {{ page }} / {{ totalPages }}</span>
      <button
        type="button"
        (click)="next.emit()"
        [disabled]="page >= totalPages"
        aria-label="Page suivante"
      >
        ›
      </button>
    </div>
  }
</div>
